import moment from 'moment';
import { ColumnConfiguration } from '../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types';
import { getSelectorTypeByColumn } from '../../../baseComponents/TwinTable/functions';
import { BuildedOrder, OrderFields, SingleFieldsSearch, Where } from '../../../baseComponents/TwinTable/types';
import { stringToDate } from '../../../utils/globals/date';
import { TwinDictionary, dictionaryComplexFromJsonArr } from '../../../utils/globals/dictionary';
import { SelectedColumnsTy, SelectedFiltersTy } from '../../../utils/hooks/useConfigColumns';
import { TableWhereSearchBarTy } from './types';

export const parseTaskTableHeaderWhereParams = (headerTableWhereParams: TableWhereSearchBarTy) => {
    const result: TwinDictionary = JSON.parse(JSON.stringify(headerTableWhereParams))
    result.start_createdAt = stringToDate(headerTableWhereParams['start_createdAt'])
    result.end_createdAt = stringToDate(headerTableWhereParams['end_createdAt'])
    result.start_date = stringToDate(headerTableWhereParams['start_date'])
    result.end_date = stringToDate(headerTableWhereParams['end_date'])
    if (result.end_date && result.end_date !== ''){
        const dateEnd = moment(result.end_date).endOf('day').toDate()
        result.end_date = dateEnd.toUTCString()
    }
    if (result.end_createdAt && result.end_createdAt !== ''){
        const dateEnd = moment(result.end_createdAt).endOf('day').toDate()
        result.end_createdAt = dateEnd.toUTCString()
    }
    return result
}

export const getWhereTaskFromSingleFields = (singleFieldsSearch: SingleFieldsSearch, columns: ColumnConfiguration[]) => {
    let where: Where = {}
    const dictColumns: { [id: string]: ColumnConfiguration } = dictionaryComplexFromJsonArr(columns)
    for (const searchFieldKey in singleFieldsSearch) {
        const column = dictColumns[searchFieldKey]
        const typeSearch = getSelectorTypeByColumn(column)
        const searchFieldValue = singleFieldsSearch[searchFieldKey]
        const parsedSearchFieldKey = column.searchKey || searchFieldKey
        if (searchFieldValue) {
            if (typeSearch === 'selector') {
                where[parsedSearchFieldKey] = searchFieldValue
            } else {
                where[parsedSearchFieldKey] = { $iLike: '%' + searchFieldValue + '%' }
            }
        }
    }
    return where
}

export const getTaskWhereFromFilters = (selectedFilters: SelectedFiltersTy, columns: ColumnConfiguration[]) => {
    let where: Where = {}
    const dictColumns: { [id: string]: ColumnConfiguration } = dictionaryComplexFromJsonArr(columns)
    for (const searchFieldKey in selectedFilters) {
        const singleFilter = selectedFilters[searchFieldKey]
        const column = dictColumns[searchFieldKey]
        const typeSearch = getSelectorTypeByColumn(column)
        const searchFieldValue = singleFilter.value
        const parsedSearchFieldKey = column?.searchSingleKey || column?.searchKey || column.dataKey
        const excluded = singleFilter.excluded || false
        if (searchFieldValue) {
            if (typeSearch === 'singleSelector') {
                where[parsedSearchFieldKey] = searchFieldValue
            }else if (typeSearch === 'selector') {
                if (excluded) {
                    where[parsedSearchFieldKey] = { $notIn: searchFieldValue }
                } else {
                    where[parsedSearchFieldKey] = { $in: searchFieldValue }
                }
            } else {
                if (Array.isArray(searchFieldValue)) {
                    let myOrAnd = []
                    for (const element of searchFieldValue) {
                        myOrAnd.push(getValueOfSingleFilterForWriteFilter(element, excluded))
                    }
                    if (excluded) {
                        where[parsedSearchFieldKey] = { $and: myOrAnd }
                    } else {
                        where[parsedSearchFieldKey] = { $or: myOrAnd }
                    }
                } else {
                    where[parsedSearchFieldKey] = getValueOfSingleFilterForWriteFilter(searchFieldValue, excluded)
                }
            }
        }
    }
    return where
}

const getValueOfSingleFilterForWriteFilter = (value: string, excluded: boolean) => {
    let operator = '%'
    if (value?.includes('*')) {
        operator = ''
        value = value.replaceAll('*', '%')
    }
    if (excluded) {
        return { $notILike: operator + value + operator }
    }
    return { $iLike: operator + value + operator }
}

export const buildOrderTaskTable = (orderFields: OrderFields, columns: ColumnConfiguration[]) => {
    const buildedOrder: BuildedOrder = []
    const dictColumns: { [id: string]: ColumnConfiguration } = dictionaryComplexFromJsonArr(columns)
    for (const orderFieldKey in orderFields) {
        const myOrderFieldKey = dictColumns?.[orderFieldKey]?.sortKey || orderFieldKey
        const orderFieldValue = orderFields[orderFieldKey]
        if (orderFieldValue !== null) {
            buildedOrder.push([myOrderFieldKey, orderFieldValue])
        }
    }
    return buildedOrder
}

export const getTaskCustomFieldsIds = (columns: SelectedColumnsTy) => {
    const result: string[] =[]
    for (const key in columns) {
        if(String(key).includes('customField_')){
            const id = key.split('_')
            if(id?.[1]){
                result.push(id[1])
            }
        }
    }
    return result
}
